export const MINIMUM_HERO_RECOMMENDATIONS = 10

export function getHeroRecommendationEligibility(twoTowers: App.OfferList, topDeals: App.OfferList) {
  const twoTowersSucceeded = !twoTowers.fetching && !twoTowers.error
  const topDealsSucceeded = !topDeals.fetching && !topDeals.error
  const enoughTwoTowers = twoTowers.offerIds.length >= MINIMUM_HERO_RECOMMENDATIONS

  return {
    personalisedEligible: twoTowersSucceeded && enoughTwoTowers,
    stateBasedEligible: twoTowersSucceeded && topDealsSucceeded && !enoughTwoTowers &&
      topDeals.offerIds.length >= MINIMUM_HERO_RECOMMENDATIONS,
  }
}
